
(function documentTypeDetailControllerDefinition() {
    'use strict';

    angular.module('DocumentType')
        .controller('DocumentTypeDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminDocumentTypeService', 'authExtend',
            function documentTypeDetailController($scope, config, $state, $translate, $stateParams, errors, adminDocumentTypeService, auth) {
                $scope.canSetMaxVersions = auth.isInRole('DOCUMENTTYPE MAX VERSIONS');
                $scope.viewAll = auth.isInRole('CONFIG ADMIN APPS');

                $scope.hideViewBtn = !auth.isInRole('METADATA WRITE') || !auth.isInRole('METADATA READ');
                $scope.hideViewContainerTypeBtn = !auth.isInRole('CONTAINERTYPE WRITE') || !auth.isInRole('CONTAINERTYPE READ');
                $scope.enableviewIndex = auth.isInRole('VIEW INDEX') || auth.isInRole('EDIT AND DELETE INDEX');

                adminDocumentTypeService.getById($stateParams.id, 'Detail')
                    .then(function (result) {
                        $scope.documentType = result;
                        $scope.documentType.maxDocumentVersion = $scope.documentType.maxDocumentVersion == null ? 0 : $scope.documentType.maxDocumentVersion;
                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-type-find');
                    });

                $scope.cancel = function () {
                    $state.go('document-type-find');
                };

                $scope.createFrom = function (documentType) {
                    $state.go('document-type-from-template', { id: documentType.id });
                }

                $scope.view = function (metadata) {
                    $state.go('metadata-detail', { id: metadata.metadataId });
                };

                $scope.viewContainerType = function (containerType) {
                    $state.go('container-type-detail', { id: containerType.containerTypeId });
                };

                $scope.disableViewBtn = function (metadata) {
                    if (metadata.metadataOrganizationalUnitId != null) {
                        return false;
                    }
                    return true;
                };

                $scope.viewIndex = function () {
                    $state.go('dba-detail', { key: 'TD', id: $scope.documentType.id });
                };
            }
        ]);
})();